import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'

export default class AuthenticationApi {
    getConfig() {
        const localStorageKeys = Object.keys(localStorage)
        let token = ''

        if (localStorageKeys.includes('usuario')) {
            token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        } else if (localStorageKeys.includes('authentication-admin')) {
            token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin')).token : ''
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    updateProfile(data) {
        return axios.post(`${URL_API}/atualizar-perfil`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    changePassword(data) {
        return axios.post(`${URL_API}/alterar-senha`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    login(data) {
        return axios.post(`${URL_API}/login`, { ...data, code_access: process.env.APPLICATION_ACCESS })
    }

    forgotPassword(data) {
        return axios.post(`${URL_API}/security/esquecer-senha`, { ...data, code_access: process.env.APPLICATION_ACCESS })
    }

    createNewPassword(data) {
        return axios.post(`${URL_API}/security/nova-senha`, { ...data, code_access: process.env.APPLICATION_ACCESS })
    }

    confirmPwdByEmail(data) {
        return axios.post(`${URL_API}/security/check-code`, { ...data, code_access: process.env.APPLICATION_ACCESS })
    }

    logout() {
        return axios.get(`${URL_API}/logout`, this.getConfig())
    }

    getUser() {
        return axios.get(`${URL_API}/list-user`, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/authentication/AuthenticationApi.js